import { render } from "./MenuComponent.vue?vue&type=template&id=305a5d6e&scoped=true"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"

import "./MenuComponent.vue?vue&type=style&index=0&id=305a5d6e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src951152977/src/zeus-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305a5d6e"]])

export default __exports__